
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { CardElement, Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { FiLoader } from "react-icons/fi";
import { BsArrowLeft } from "react-icons/bs";
import toast, { Toaster } from 'react-hot-toast';
import SelectOptions from './components/SelectOptions';
import DatePicker from './components/DatePicker';
import axios from 'axios';
import full from './full_logo.png';
export const config = {
    Accept: 'application/json',
    headers: {
        // Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
};
const baseURL = process.env.REACT_APP_BASE_URL;
const MenuOptions = [
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'week' },
    { label: 'Month', value: 'month' },
    { label: 'Annual', value: 'week' },
  ];

function CreateNewSub() {
    const { id, aid } = useParams();
    const stripePromise = loadStripe('pk_live_51MATahFPa7IBDUHEqnXyPdmut1sQ871Bk7zJAY3wDMqFUh353RLjxR0C3VTeKJzlgpFwIcsC5VzXUsGknKCGXpR100ZWbpvHR4', {
        stripeAccount: aid,
    });
    const [loading, setLoading] = useState(true);
    const [AddressLine, setAddressLine] = useState('');
    const [zipcode, setzipcode] = useState('');
    const [Province, setProvince] = useState('');
    const [city, setcity] = useState('');
    const [Email, setEmail] = useState('');
    const [PhoneNumber, setPhoneNumber] = useState('');
    const [planName, setPlanName] = useState('');
    const [Description, setDescription] = useState('');
    const [Amount, setAmount] = useState('');
    const [trialPeriod, setTrialPeriod] = useState('');
    const [scheduleStartDate, setScheduleStartDate] = useState(new Date());
    const [scheduleEndDate, setScheduleEndDate] = useState(new Date());
    const [selectedInterval, setSelectedInterval] = useState('month');
    const [companyName, setCompanyName] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    const [address, setAddress] = useState([]);
    useEffect(() => {
        setLoading(true);
        handlegetCompanyName();
    }, []);
    const handlegetCompanyName = async () => {
        const response = await axios.get(`${baseURL}/company/unauthenticated-get-company/${id}`, {
            headers: {
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
            }
        })
        setCompanyName(response?.data?.data?.entity?.name);
        setCompanyLogo(response?.data?.data?.entity?.profile_photo_url);
        setAddress(response?.data?.data?.entity?.address_data);
        setLoading(false);
    }
    useEffect(() => {
        const futureDate = new Date(scheduleStartDate);
        const today = new Date();
        const timeDifference = futureDate - today;
        const millisecondsInADay = 24 * 60 * 60 * 1000;
        const daysDifference = Math.floor(timeDifference / millisecondsInADay);
        setTrialPeriod(`${Number(daysDifference) + 1}`);
      }, [scheduleStartDate]);

    const handleChangeCard = async (e, elements, stripe) => {
        e.preventDefault();
        if (!stripe || !elements) {
          return;
        }
        // setLoading(true);
        stripe
          .createPaymentMethod({
            elements,
            params: {
              billing_details: {
                email: Email,
              },
            },
          })
          .then(async function (result) {
            if (result.error) {
              toast.error(result.error.message);
              setLoading(false);
            } else {
              setLoading(true);
              const formdata = {
                name: null,
                email: Email,
                payment_method_id: result.paymentMethod.id,
                phone: PhoneNumber === '' ? null : PhoneNumber,
                address: {
                  line1: AddressLine,
                  line2: null,
                  postal_code: zipcode,
                  state: Province,
                  city: city,
                  country: 'US',
                },
                plan_name: planName,
                interval: selectedInterval,
                price: `${Number(Amount) * 100}`,
                trial_period_days: trialPeriod,
                description: Description,
              };
              const res = await axios.post(`${baseURL}/subscription/create-subscription/${id}/${aid}`, formdata, config);
              if (res?.data?.status !== 'success') {
                toast.error(res?.data.message);
                setLoading(false);
              } else {
                toast.success(res?.data.message);
                setTimeout(() => {
                    window.location.href = `${process.env.REACT_APP_MAIN_URL}/dashboard/payments/subscription`;
                }, [3000]);
              }
            }
          })
          .catch((error) => console.error(error));
      };

    if (loading) {
        return (
            <div className="w-full h-[100vh] items-center justify-between flex flex-col">
                <FiLoader size={50} className="animate-spin mt-[47vh]" />
                <div className='bg-[#fff] flex justify-center items-center relative text-[20px] pb-2 h-[1.5rem] w-full rounded-b-[8px] mb-[5vh]'>
                    {/* <a href="https://salescaptain.com/" target="_blank" className='underline text-blue-600 font-semibold' rel="noreferrer">
              Visit our website
            </a> */}

                    <span className="text-[#535355]"> Powered by</span>
                    <div
                        className='flex items-center ml-1 cursor-pointer'
                    >
                        <img src={localStorage.getItem('h_url') ?? 'https://s3.us-east-2.amazonaws.com/sc-prod-embedded.salescaptain.com/resources/2023-07-22/sales_captain_1690015901642.png'} className=" h-[18px]" alt="" />
                        <span
                            className="font-semibold ml-1"
                        >
                            {localStorage.getItem('h_name') ?? 'SalesCaptain'}
                        </span>
                    </div>
                </div>

            </div>
        );
    };
    const isValid = (Email.length > 0 && planName?.length > 0 && zipcode?.length > 0 && Amount?.length > 0 && Province.length > 0 && city?.length > 0 && zipcode?.length > 0);

    return (
        <div className="h-screen w-screen flex flex-col items-center justify-center  overflow-x-hidden overflow-y-auto">
            <div className="absolute left-0 top-2">
                <div className="flex">
                    <div className=" pb-4 justify-between grid grid-col-2">
                        <a href={`${process.env.REACT_APP_MAIN_URL}/dashboard/payments/subscription`} className="inbox-message ">
                            <div className="flex items-center space-x-3 pl-[1rem] pt-[1rem]">
                                <div className="text-xs cursor-pointer flex items-center gap-2">
                                    <BsArrowLeft
                                        size={20}
                                        className="mr-1"
                                    />
                                </div>
                                <span className="medium  capitalize ">
                                    Back to
                                    {` ${localStorage.getItem('h_name') ?? 'SalesCaptain'}`}
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div className="flex gap-3 items-center  text-[#1a1a1ab3] medium text-[15px]">
                {companyLogo && (
                    <span className="text-[#1a1a1ab3] medium text-[15px] bg-white  
            p-1 w-[60px] h-[60px] rounded-md object-fill"
                    >
                        {' '}
                        <img className="w-full h-full" src={companyLogo} alt="" />

                    </span>
                )}
                <div className="flex flex-col gap-1">
                    <span className="text-[#3975cb]  medium text-[18px] tracking-wide">{companyName}</span>
                    <span className="regular text-[10px] tracking-wide">
                        {address?.street_address}
                        {' '}
                        {address?.apartment_or_suite}
                        {' '}
                        {address?.city}
                        {' '}
                        {address?.zip}
                    </span>
                </div>
            </div>

            <div className="space-y-2 text-gray-500 shadow-xl flex flex-col rounded-[25px] border-[1px] border-[#E2E8F0] p-3 px-7 w-[450px] mt-3">
                <div className=" h-fit flex flex-col space-y-2 space-x-2">
                    <div className="  text-left ">
                        <Elements stripe={stripePromise}>
                            <ElementsConsumer>
                                {({ elements, stripe }) => (
                                    <div className="w-full flex  flex-col items-center justify-center mt-3 p-3 sm:p-1">
                                        <div className="flex flex-col w-[100%] py-2 ">

                                            <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Card Detail</div>
                                            <CardElement className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white  resize-none
                        rounded-[8px] outline-none  p-3 disabled:bg-gray-300 text-sm placeholder:text-sm
                        hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                            />
                                        </div>
                                        <div className="flex sm:flex-row flex-col w-[100%]">
                                            <div item className="flex-col  w-full py-2">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Email</div>
                                                <textarea
                                                    name="Email"
                                                    value={Email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                            <div item className="flex-col sm:pl-2 py-2 w-full">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">PhoneNumber</div>
                                                <textarea
                                                    name="code"
                                                    value={PhoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                    onKeyPress={(e) => {
                                                        const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'];
                                                        if (!validKeys.includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    maxLength={10}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex sm:flex-row flex-col w-[100%]">
                                            <div item className="flex-col  w-full py-2">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Plan Name</div>
                                                <textarea
                                                    name="planname"
                                                    value={planName}
                                                    onChange={(e) => setPlanName(e.target.value)}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                            <div item className="flex-col sm:pl-2 py-2 w-full">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Amount</div>
                                                <textarea
                                                    name="code"
                                                    value={Amount}
                                                    onChange={(e) => setAmount(e.target.value)}
                                                    onKeyPress={(e) => {
                                                        const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '.'];
                                                        if (!validKeys.includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex sm:flex-row flex-col w-[100%]">
                                            <div item className="flex-col  w-full py-2">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Address Line</div>
                                                <textarea
                                                    name="AddressLine"
                                                    value={AddressLine}
                                                    onChange={(e) => setAddressLine(e.target.value)}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                            <div item className="flex-col sm:pl-2 py-2 w-full">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">City</div>
                                                <textarea
                                                    name="city"
                                                    value={city}
                                                    onChange={(e) => setcity(e.target.value)}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col  w-[100%] py-2">
                                            <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Description</div>
                                            <textarea
                                                name="Description"
                                                value={Description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[60px] resize-y
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                            />
                                        </div>
                                        <div className="flex sm:flex-row flex-col w-[100%]">
                                            <div item className="flex-col  w-full py-2">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Province</div>
                                                <textarea
                                                    name="Province"
                                                    value={Province}
                                                    onChange={(e) => setProvince(e.target.value)}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                            <div item className="flex-col sm:pl-2 py-2 w-full">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Postal code</div>
                                                <textarea
                                                    name="code"
                                                    value={zipcode}
                                                    onChange={(e) => setzipcode(e.target.value)}
                                                    onKeyPress={(e) => {
                                                        const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                                        if (!validKeys.includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    className="hover:!ring-2 w-[100%] shadow-sm shadow-gray-200 hover:!border-[1px] border !bg-white max-h-[120px] min-h-[40px] h-[40px] resize-none
                            rounded-[8px] outline-none  p-2 disabled:bg-gray-300 text-sm placeholder:text-sm
                            hover:!ring-blue-200  hover:!border-blue-500 focus:!ring-4 focus:!ring-blue-200 focus:!border-blue-500"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex sm:flex-row flex-col w-[100%]">
                                            <div item className="flex-col  py-2 w-full">
                                                <div className="text-[11px] pb-[8px] pl-1 text-slate-700">
                                                    {` `}
                                                </div>
                                                <DatePicker
                                                    scheduleStartDate={scheduleStartDate}
                                                    setScheduleStartDate={setScheduleStartDate}
                                                    scheduleEndDate={scheduleEndDate}
                                                    setScheduleEndDate={setScheduleEndDate}
                                                />
                                            </div>
                                            <div item className="flex-col pl-4  w-full py-2">
                                                <div className="text-[11px] pb-1.5 pl-1 text-slate-700">Time Period</div>
                                                <SelectOptions
                                                    size="small"
                                                    value={selectedInterval}
                                                    setValue={setSelectedInterval}
                                                    menuOptions={MenuOptions}
                                                    maxHeight="36px"
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col  w-[100%] py-4">
                                            <div className="text-gray-500 flex item-center justify-center font-bold text-[17px] ">
                                                <button type="submit" onClick={(e) => { handleChangeCard(e, elements, stripe); }} disabled={!(stripe && isValid)} className="flex items-center w-full justify-center  disabled:!bg-gray-400   !bg-blue-500 mt-2  font-semibold shadow-md shadow-gray-200 focus:ring-4 gap-1  border border-gray-300 text-white regular text-[14px] rounded-[18px] focus:!ring-blue-200 focus:!border-blue-500  focus:border-[1px] p-2.5">Create Subscription</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </ElementsConsumer>
                        </Elements>
                    </div>
                </div>
            </div>
            <div className='flex justify-center gap-2 items-center mt-5'>
                <span className="text-gray-400 regular self-center mt-1 text-[10px]">Powered by </span>
                <img className=" h-[14px]" src={full} alt="" />
            </div>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
        </div>
    );
}

export default CreateNewSub;